import React from "react"
import { ACTIVITY_FEED_EVENT_TYPE } from "../../../state/activity-feed/ActivityFeedEventType"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import Icon from "../../../common/icon/icon.component.jsx"
import PaymentTypeIcon from "../../../invoice/paymenttypeicon.component.jsx"

type Props = {
    activity: ActivityFeedEventSearchResult,
}

const getPaymentTypeIcon = (activity: ActivityFeedEventSearchResult): JSX.Element => {
    const parsedData = JSON.parse(activity.getObjectDataJson())
    const paymentTypeId = parsedData.paymentTypeId
    return <PaymentTypeIcon value={paymentTypeId} />
}

const getGenericIcon = (iconValue: string): JSX.Element => {
    return <Icon value={iconValue} />
}

const ActivityFeedEventIcon = (props: Props) => {

    switch (props.activity.getActivityType()) {
    case ACTIVITY_FEED_EVENT_TYPE.SMS_RECEIVED:
        return getGenericIcon("mobile-alt")
    case ACTIVITY_FEED_EVENT_TYPE.CHAT_MESSAGE_RECEIVED:
        return getGenericIcon("comment")
    case ACTIVITY_FEED_EVENT_TYPE.DOCUMENT_SIGNED:
        return getGenericIcon("pen")
    case ACTIVITY_FEED_EVENT_TYPE.QUOTE_STATUS_APPROVED:
        return getGenericIcon("thumbs-up")
    case ACTIVITY_FEED_EVENT_TYPE.QUOTE_STATUS_DECLINED:
        return getGenericIcon("thumbs-down")
    case ACTIVITY_FEED_EVENT_TYPE.QUOTE_PAYMENT_CAPTURED:
    case ACTIVITY_FEED_EVENT_TYPE.ORDER_PAYMENT_CAPTURED:
    case ACTIVITY_FEED_EVENT_TYPE.INVOICE_PAYMENT_CAPTURED:
        return getPaymentTypeIcon(props.activity)
    case ACTIVITY_FEED_EVENT_TYPE.INVOICE_SYNC_RECEIVED:
        return getGenericIcon("rotate-exclamation")
    default:
        return <></>
    }
}

export default ActivityFeedEventIcon


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventIconComponent.tsx